<template>

  <div class="container">

    <div class="handle-box-search">



      <el-button type="primary" icon="el-icon-search" @click="searchalipayLists">搜索</el-button>
      <el-button @click="addAlipay_show = !addAlipay_show">添加</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">


      <el-table-column prop="app_id" label="APP唯一标识">
      </el-table-column>

      <el-table-column prop="privateKey" label="支付宝私钥">
      </el-table-column>

      <el-table-column prop="publicKey" label="支付宝公钥">
      </el-table-column>



      <el-table-column prop="status.alias" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
            {{scope.row.status.alias}}</el-tag>
        </template>
      </el-table-column>



      <el-table-column prop="time.YmdHis" label="详细时间">
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-dropdown split-button type="primary"
            @click="editAlipay_show = !editAlipay_show; editAlipay_data = scope.row.alipay_code; " trigger="click">

            编辑

            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item @click.native="delMerchants(scope.row.alipay_code)">删除</el-dropdown-item>

            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>



    <!-- 添加组件 -->
    <addAlipay :isShow="addAlipay_show" @onSubmit="alipayLists"></addAlipay>



    <!-- 编辑组件 -->
    <editAlipay :isShow="editAlipay_show" @onSubmit="alipayLists" :data="editAlipay_data"></editAlipay>

  </div>

</template>

<script>
  var _this;
  import addAlipay from './addAlipay.vue';
  import editAlipay from './editAlipay.vue';
  export default {

    components: {
      addAlipay,
      editAlipay
    },

    data() {
      return {



        addAlipay_show: false,
        editAlipay_show:false,
        editAlipay_data:'',




        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.alipayLists();
    },

    methods: {

      delMerchants(code) {

        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {

          _this.$post(
            "/Alipay/delAlipaySubmit", {
              alipay_code: code
            }
          )
          .then(res => {


            _this.$message.success(res.msg);
            _this.alipayLists();

          }).catch((err) => {

          })

        }).catch(() => {

          _this.$message({
            message: '已取消删除',
            duration: 1500
          });

        });







      },





      searchalipayLists() {

        _this.search_data.page = 1;
        _this.alipayLists();

      },


      alipayLists() {
        _this.$post(
            "/Alipay/alipayLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {


            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.alipayLists();

      },


      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>